import { jsx as s, jsxs as r, Fragment as t } from "react/jsx-runtime";
import c from "../../utils/classNames.js";
const f = (i) => {
  const { bsSize: n = "md", inputAddon: o, errorMessage: e, warningMessage: a, messageWhiteSpace: l = "normal", children: p } = i, d = c(
    "form-group margin-bottom-0",
    (e || a) && "has-feedback",
    e && "has-error",
    a && "has-warning"
  ), m = c(
    "input-group",
    n === "sm" && "input-group-sm",
    n === "lg" && "input-group-lg"
  );
  return /* @__PURE__ */ s("div", { className: d, children: /* @__PURE__ */ r("div", { className: m, children: [
    o && /* @__PURE__ */ s("div", { className: "input-group-addon", children: /* @__PURE__ */ s("span", { className: o }) }),
    /* @__PURE__ */ r("div", { className: "form-control-feedback-wrapper", children: [
      p,
      (e || a) && /* @__PURE__ */ r(t, { children: [
        e && /* @__PURE__ */ s("span", { className: "form-control-feedback rioglyph rioglyph-error-sign" }),
        a && /* @__PURE__ */ s("span", { className: "form-control-feedback rioglyph rioglyph-warning-sign" }),
        /* @__PURE__ */ s("span", { className: `help-block white-space-${l}`, children: /* @__PURE__ */ s("span", { children: e || a }) })
      ] })
    ] })
  ] }) });
};
export {
  f as default
};
//# sourceMappingURL=WithFeedbackAndAddon.js.map
